<template lang="pug">
AppMainMenu
router-view
       //- views render here
</template>

<script lang="ts">
import { mapGetters } from 'vuex';
import { defineComponent, computed } from 'vue';
import { useRoute } from 'vue-router';

import AppMainMenu from '@/components/AppMainMenu.vue';

export default defineComponent({
  name: 'DashView',
  components: { AppMainMenu },
  computed: {
    ...mapGetters('shared', ['isMainMenuCollapsed']),
  },
  setup() {
    const route = useRoute();
    
    const isWebRoute = computed(() => {
      return route.path.startsWith('/web');
    });
    
    return {
      isWebRoute
    };
  }
});
</script>
